//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[],[[["update_option"],"UpdateViews",{},1,0],[["update_option","drawing"],"UpdateViews1",{},2,0],[["views"],"UpdateViews2",{},1,0],[["view"],"SuppressViewBreaks",{},1,0],[["view"],"RestoreViewBreaks",{},1,0],[["view"],"UpdateViewBreaks",{},1,0],[["drawing","views","detail_option","annot_option","numNewViews","newViews"],"PasteViews",{},4,0],[["views","drawing"],"MoveViewsToDrawing",{},2,0],[["journal_identifier"],"FindObject",{R_:{found:"Drawings.DraftingView"}},1,0],[["view"],"GetParentOfView",{R_:{parentView:"ModelingView"}},1,0],[["views"],"DeleteViewsInOriginalPart",{},1,0],[[],"CreateUpdateViewsBuilder",{R_:{builder:"Drawings.UpdateViewsBuilder"}},0,0],[["view"],"CreateBaseViewBuilder",{R_:{builder:"Drawings.BaseViewBuilder"}},1,0],[["view"],"CreateProjectedViewBuilder",{R_:{builder:"Drawings.ProjectedViewBuilder"}},1,0],[["sectionViewOrSectionLine"],"CreateSectionViewBuilder",{R_:{builder:"Drawings.SectionViewBuilder"}},1,0],[[],"CreateSectionInViewBuilder",{R_:{builder:"Drawings.SectionInViewBuilder"}},0,0],[["drawingview"],"CreateDrawingViewBuilder",{R_:{builder:"Drawings.DrawingViewBuilder"}},1,0],[["view"],"CreateDetailViewBuilder",{R_:{builder:"Drawings.DetailViewBuilder"}},1,0],[[],"CreateCopyTo3dBuilder",{R_:{builder:"Drawings.ViewCopyTo3dBuilder"}},0,0],[[],"CreateStandardViewsBuilder",{R_:{builder:"Drawings.StandardViewsBuilder"}},0,0],[[],"CreateViewProjectionBuilder",{R_:{builder:"Drawings.ViewProjectionBuilder"}},0,0],[["viewbreak"],"CreateBrokenViewBuilder",{R_:{builder:"Drawings.BrokenViewBuilder"}},1,0],[["views"],"ConvertLegacyViewsToLightweight",{},1,0],[[],"CreateRefineDisplayBuilder",{R_:{builder:"Drawings.RefineDisplayBuilder"}},0,1],[["activeView"],"CreateAddRemoveBoxViewBuilder",{R_:{builder:"Drawings.AddRemoveBoxViewBuilder"}},1,0],[[],"CreateViewCreationWizardBuilder",{R_:{builder:"Drawings.ViewCreationWizardBuilder"}},0,0],[[],"CreateShipbuildingLineBuilder",{R_:{style:"Drawings.ViewStyleShipbuildingLinesBuilder"}},0,0],[[],"CreateCustomViewSettingsBuilder",{R_:{builder:"Drawings.CustomViewSettingsBuilder"}},0,0],[[],"CreateSecondaryGeometryInViewsBuilder",{R_:{builder:"Drawings.SecondaryGeometryInViewsBuilder"}},0,0],[["inputViews"],"UpdateSheetsAndViews",{},1,0],[["view"],"ApplyAlignmentsForProjectedView",{},1,0]],[]];
SPLM.Drawings.DraftingViewCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.DraftingViewCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Drawings.DraftingViewCollection.ViewUpdateOption = Object.freeze({
    "All" : "All", "OutOfDate" : "OutOfDate", "OutOfDateAutomatic" : "OutOfDateAutomatic"});

SPLM.Drawings.DraftingViewCollection.ViewCopyAnnotOption = Object.freeze({
    "CopyAnnotation" : "CopyAnnotation", "DontCopyAnnotation" : "DontCopyAnnotation"});

SPLM.Drawings.DraftingViewCollection.ViewCopyDetailOption = Object.freeze({
    "DetailView" : "DetailView", "DuplicateView" : "DuplicateView", "ModelView" : "ModelView"});

export default SPLM;